// Helper function to pass axios error responses to our error handling callbacks
const displayBackendErrors = (
  error,
  setFieldErrorCallback,
  setNonFieldErrorCallback,
  formControls,
) => {
  const backendErrors = error.response?.data;
  // Serializer field errors are returned as plain dictionary responses. Anything else
  // (a string, an array, an unhandled-exception HTML page, etc.) can't be matched up
  // against form fields, so it should always be treated as a non-field error.
  const isFieldErrorDict = !!backendErrors
    && typeof backendErrors === 'object'
    && !Array.isArray(backendErrors);

  if (!isFieldErrorDict) {
    setNonFieldErrorCallback(backendErrors || error);
    return;
  }

  // PressReleaseSerializer contains fields that are not explicitly
  // fields on the form (Ex: press_contacts, multimedia_add_ons), so identify
  // the fields that are on the page. Some callers don't track field-level errors
  // (no formControls/setFieldErrorCallback provided), in which case everything
  // falls through to the non-field error callback.
  const fieldNames = (formControls || []).map((obj) => obj.fieldName);
  Object.entries(backendErrors).forEach(([key, value]) => {
    if (setFieldErrorCallback && fieldNames.includes(key)) {
      setFieldErrorCallback(key, value[0]);
    } else setNonFieldErrorCallback(value);
  });
};

export default displayBackendErrors;
